import StepId from "@/model/progress/StepId"
import RouteType from "@/model/route/RouteType"
import { providerState, sessionState } from "@/state"

const providerKey = "claritypay_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "claritypayResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: `/providers/${providerKey}/paymentPlans`
        },
        {
            name: "claritypayResume",
            path: `/providers/${providerKey}/resume`,
            meta: { step: StepId.APPLICANT_INFO, stepper: false },
            component: () => import(/* webpackChunkName: "claritypay" */ "@/views/provider/claritypay/ClarityPayResumeView.vue"),
        },
        {
            name: "claritypayOfferReviewNext",
            path: `/providers/${providerKey}/offerReviewNext`,
            redirect: `/providers/${providerKey}/terms`,
        },
        {
            name: "claritypayPatchSuccessful",
            path: `/providers/${providerKey}/patchSuccessful`,
            redirect: `/providers/${providerKey}/complete`,
        },
        {
            name: "claritypayPrequalifyOfferReviewNext",
            path: `/providers/${providerKey}/modes/prequalify/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            redirect: `/providers/${providerKey}/checkCalifornia`,
        },
        {
            name: "claritypayPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.PAYMENT_OPTIONS },
            component: () => import("@/views/provider/claritypay/ClarityPaymentPlanReviewView.vue"),
        },
        {
            name: "claritypayPrequalifyTerms",
            path: `/providers/${providerKey}/terms`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import(/* webpackChunkName: "claritypay" */ "@/views/provider/claritypay/ClarityPayIframeView.vue"),
        },
        {
            name: "claritypayApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            extends: "approved",
            component: () => import(/* webpackChunkName: "claritypay" */ "@/views/provider/claritypay/ClarityPayCompleteView.vue"),

        },
        {
            name: "claritypayComplete",
            path: `/providers/${providerKey}/complete`,
            meta: { step: StepId.COMPLETE },
            component: () => import(/* webpackChunkName: "claritypay" */ "@/views/provider/claritypay/ClarityPayCompleteView.vue"),
        },
        {
            name: "claritypayPending",
            path: `/providers/${providerKey}/pending`,
            meta: { step: StepId.COMPLETE, stepper: true },
            extends: "pending",
            component: () => import(/* webpackChunkName: "claritypay" */ "@/views/provider/claritypay/ClarityPayIframeView.vue"),
        },
        {
            name: "claritypayResumeFromPrequalifiedReview",
            path: `/providers/${providerKey}/resume/from-prequalified`,
            meta: { step: StepId.PAYMENT_OPTIONS},
            redirect: () => {
                let preauthResponse = providerState.getPreAuthResponse(sessionState.providerKey)
                if (
                    preauthResponse &&
                    preauthResponse.responseCode === "pending" &&
                    preauthResponse.pendingReasons?.length &&
                    (preauthResponse?.pendingReasons?.includes("esign"))
                ) {
                    return `/providers/${providerKey}/terms`
                }

                return `/providers/${providerKey}/paymentPlans`
            },
        },
        {
            name: "claritypayResumeFromPaymentPlanReview",
            path: `/providers/${providerKey}/resume/from-payment-plan-review`,
            redirect: `/providers/${providerKey}/paymentPlans`,
        },
    ],
}
